import { render, staticRenderFns } from "./UpdateChannel.vue?vue&type=template&id=2cdd5bb0&scoped=true"
import script from "./UpdateChannel.vue?vue&type=script&lang=js"
export * from "./UpdateChannel.vue?vue&type=script&lang=js"
import style0 from "./UpdateChannel.vue?vue&type=style&index=0&id=2cdd5bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdd5bb0",
  null
  
)

export default component.exports